import axios from "axios";

// Set the base URL from environment or default
const API_URL =
  import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api/notifications";

// Create an Axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to attach token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Notification API methods
export const notificationAPI = {
  /**
   * Get current user's notifications with optional pagination
   * @param {Object} params - { page: Number, limit: Number }
   */
  getUserNotifications: async ({ page = 1, limit = 20 } = {}) => {
    try {
      const response = await api.get("/user", {
        params: { page, limit },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Mark a specific notification as read
   * @param {string} notificationId
   */
  markAsRead: async (notificationId) => {
    try {
      const response = await api.put(`/read/${notificationId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Mark all user notifications as read
   */
  markAllAsRead: async () => {
    try {
      const response = await api.put("/read-all");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Send a notification to a specific user (admin/staff use)
   * @param {Object} notificationData
   */
  sendNotificationToUser: async (notificationData) => {
    try {
      const response = await api.post("/send", notificationData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Send notifications to multiple users (admin use)
   * @param {Object} bulkData
   */
  sendBulkNotifications: async (bulkData) => {
    try {
      const response = await api.post("/send-bulk", bulkData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Send a notification to a staff member by staffId (admin/subAdmin use)
   * @param {Object} param0 - { staffId: string, notificationData: Object }
   */
  sendNotificationToStaff: async ({ staffId, notificationData }) => {
    try {
      const response = await api.post(`/${staffId}`, notificationData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Send an announcement to all employees except customers (admin/subAdmin use)
   * @param {Object} data - { message, senderUserId }
   */
  sendAnnouncementToAll: async (data) => {
    try {
      console.log(data, "2");
      const response = await api.post("/send-announcement", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  sendAnnouncementToTypes: async (data) => {
    try {
      const response = await api.post("/send-announcement-to-types", data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Get all announcements (for Announcements page)
   */
  getAllAnnouncements: async () => {
    try {
      const response = await api.get("/announcements");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
